import { SOCIAL_LINKS } from './footerData';

export default function FooterBottomBar() {
  return (
    <div
      className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
      style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}
    >
      <p className="text-xs" style={{ color: '#334155' }}>
        &copy; 2026 MobileCoreX Limited. RC 6977362. Abuja, Nigeria.
      </p>
      <p className="text-xs" style={{ color: '#1E293B' }}>
        Built on Tier-III certified colocation infrastructure.
      </p>
      <div className="flex items-center gap-5">
        {SOCIAL_LINKS.map(([label, href]) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs transition-colors duration-200 hover:text-white"
            style={{ color: '#475569' }}
          >
            {label}
          </a>
        ))}
      </div>
    </div>
  );
}
